import Vue from 'vue';
import moment from 'moment';
//import { v4 as uuidv4 } from 'uuid';
import '@/filters';
import {
  DxDataGrid,
  DxColumn,
  DxButton,
  DxGrouping,
  DxGroupPanel,
  DxSearchPanel,
  DxColumnChooser,
  DxExport,
  DxSelection,
  DxPaging,
  DxSorting,
  DxHeaderFilter,
  DxFilterPanel,
  DxFilterRow,
  DxFilterBuilderPopup,
  DxScrolling,
  DxSummary,
  DxStateStoring,
  DxGroupItem,
  DxTotalItem,
  DxEditing,
  DxPager,
  DxColumnFixing
} from 'devextreme-vue/data-grid';

import { DxCheckBox } from 'devextreme-vue/check-box';
import { field } from 'devexpress-reporting/designer/controls/metadata/pivotgrid/sortBySummary';
import { value } from 'devexpress-dashboard/model/index.metadata';
import ldt from '@/localDataFunctions';
import { mixins } from 'vue-class-component';

export default {
  name: 'ApplicationsDatagrid',
  components: {
    DxCheckBox,
    DxColumn,
    DxButton,
    DxGroupPanel,
    DxGrouping,
    DxPaging,
    DxSorting,
    DxSearchPanel,
    DxColumnChooser,
    DxExport,
    DxSelection,
    DxHeaderFilter,
    DxFilterPanel,
    DxFilterRow,
    DxFilterBuilderPopup,
    DxScrolling,
    DxSummary,
    DxStateStoring,
    DxGroupItem,
    DxTotalItem,
    DxEditing,
    DxDataGrid,
    DxPager,
    DxColumnFixing,
    ConditionalFormatting: require('./conditionalFormatting/conditionalFormatting.vue').default
  },
  props: {
    ///////////////////////////////////////////////////
    doubleClickNoteRemove: {
      type: Boolean,
      default: false
    },
    showDoubleClickNotes: {
      type: Boolean,
      default: true
    },
    showSingleClickNotes: {
      type: Boolean,
      default: false
    },
    showDoubleClickNotesEdit: {
      type: Boolean,
      default: false
    },
    onCellClick: {
      type: Function
    },
    onRowDbClick: {
      type: Function
    },
    selectionChanged: {
      type: Function
    },
    //////////////////////////////////////////////////
    pageSize: {
      type: Number,
      default: 100
    },
    title: {
      type: String,
      default: ''
    },
    data_source: {
      type: Array,
      required: true
    },
    cols: {
      type: Array,
      required: true
    },
    allowPaging: {
      type: Boolean,
      default: true
    },
    keyColumn: {
      type: String
    },
    selection: {
      type: String,
      default: 'single'
    },
    selectAllMode: {
      type: String,
      default: 'allPages'
    },
    showCheckBoxesMode: {
      type: String,
      default: 'onClick'
    },
    summaryColumn: {
      type: String
    },
    allowUpdating: {
      type: Boolean,
      default: false
    },
    allowDeleting: {
      type: Boolean,
      default: false
    },
    allowAdding: {
      type: Boolean,
      default: false
    },
    allowColumnReordering: {
      type: Boolean,
      default: true
    },
    allowColumnResizing: {
      type: Boolean,
      default: true
    },
    columnAutoWidth: {
      type: Boolean,
      default: true
    },
    rowAlternationEnable: {
      type: Boolean,
      default: true
    },
    showColumnLines: {
      type: Boolean,
      default: true
    },
    showRowLines: {
      type: Boolean,
      default: true
    },
    showBorders: {
      type: Boolean,
      default: true
    },
    calculateCellClass: {
      type: Function
    },
    rtl: {
      type: Boolean,
      default: false
    },
    totalCount: {
      type: Number,
      default: 0
    },
    pageOptions: {
      type: Object
    },
    pageChanging: {
      type: Function
    },
    isRemotePaging: {
      type: Boolean,
      default: false
    },
    isDisablePaging: {
      type: Boolean,
      default: false
    },
    stateStoringEnabled: {
      type: Boolean,
      default: false
    },
    stateStoringKey: {
      type: String
    },
    styleClass: {
      type: String,
      default: ''
    },
    clearSelection: {
      type: Function
    },
    downloadRecordsFunction: {
      type: Function,
      default: null
    },
    disableRemotePaging: {
      type: Boolean,
      default: false
    },
    showDoneButton: {
      type: Boolean,
      default: false
    },
    allowAutoExpand: {
      type: Boolean,
      default: true
    },
    allowGroupPanel: {
      type: Boolean,
      default: true
    },
    allowColumnFixing: {
      type: Boolean,
      default: false
    },
    showRefreshRecordsButt: {
      type: Boolean,
      default: true
    },
    refName: {
      type: String,
      default: 'devExtremeGrid'
    },
    employeeStationId: {
      type: Number,
      default: -1
    },
    localSaveLocation: {
      type: String,
      required: true
    }
  },
  mixins: [ldt],
  data: function () {
    return {
      lockGrid: false,
      conditionalFormattingRules: {},
      conditionalFormattingAppIds: [],
      rowsIndexSelected: [-1],
      showSearchDialog: false,
      selectedRowData: {},
      enableDownloadRecordsButt: false,
      options: { pageSize: 10, total: 0, page: 1, from: null, to: null },
      totalRow: 0,
      filterBuilderPopupPosition: {
        of: window,
        at: 'top',
        my: 'top',
        offset: { y: 10 }
      },
      editButtons: [
        {
          hint: 'Edit',
          icon: 'edit',
          visible: true,
          onClick: this.onGridCellClick
        }
      ],
      pageSizes: [5, 10, 20],
      focusedRowKey: '',
      dataGridRefName: 'dataGrid',
      localLang: '',
      selectedRowKeys: [],
      gridCols: []
    };
  },
  computed: {
    GetSummaryColumnName: function () {
      return this.summaryColumn || Object.keys(this.data_source[0])[0];
    },
    dGrid: function () {
      return this.$refs.devExtremeGrid.instance;
    },
    enableSearchDialog: function () {
      return this.data_source && this.cols && this.data_source.length > 0 && this.cols.length > 0;
    },
    searchDataSource: function () {
      return this.data_source;
    }
  },
  created() {
    this.enableDownloadRecordsButt = this.downloadRecordsFunction != null;
    //this is so the datagrid accepts the column input
    this.resetColumns();

    this.$root.$on('datagrid_updated', this.init);
    this.localLang = this.$localStorage.get('_lang');
    this.init();
  },
  mounted() {
    this.$root.$on(`refresh_data_grid:${this.refName}`, this.refreshGrid);

    this.lockGrid = this.getFromLocal('lock_grid');
  },
  beforeDestroy() {
    //this.clear();
    if (this.clearSelection) {
      this.clearSelection();
    }
  },
  methods: {
    lockGridFunc(val) {
      this.saveToLocal('lock_grid', val);
    },
    getTemplateName() {
      return 'getTemplateNames';
    },
    cellTemplate(c) {
      //console.log("c", {...c})
      return c.dataType == 'icon'
        ? 'iconCol'
        : c.stationAccessHighlight
        ? 'stationAccessHighlightApplicationCol'
        : c.highlight
        ? 'highlightApplicationCol'
        : c.accessHighlight
        ? 'accessHighlightApplicationCol'
        : c.priorityHighlight
        ? 'priorityCol'
        : c.dataField;
      //: c.tempName;
    },
    searchComplete(item) {},
    onCellPrepared(e) {
      //if (e.rowType === "data" && this.rowsIndexSelected.filter(r => r == e.rowIndex).length == 1) {
      //  e.cellElement.classList.add("cell-highlighted");
      //}
    },
    downloadRecords() {
      this.downloadRecordsFunction();
    },
    clear() {},
    init() {
      Vue.nextTick(() => {
        this.totalRow = this.data_source.length;
        this.focusedRowKey = this.keyColumn;
      });
    },
    resetColumns() {
      this.gridCols = [];
      this.gridCols = JSON.parse(JSON.stringify(this.cols));
    },
    pageChange(pInfo) {
      var parameters = { PageSize: pInfo.pageSize, Page: pInfo.pageNumber, From: this.options.from, To: this.options.to };
    },
    onFocusedRowChanging(e) {
      var pageSize = e.component.pageSize(),
        pageIndex = e.component.pageIndex(),
        isLoading = e.component.getController('data').isLoading(),
        key = e.event && e.event.key;

      if (!isLoading) {
        if (key && e.prevRowIndex === e.newRowIndex) {
          if (e.newRowIndex === pageSize - 1) {
            e.component.pageIndex(pageIndex + 1).done(function () {
              e.component.option('focusedRowIndex', 0);
            });
          } else if (e.newRowIndex === 0) {
            e.component.pageIndex(pageIndex - 1).done(function () {
              e.component.option('focusedRowIndex', pageSize - 1);
            });
          }
        }
      }

      if (this.selectionChanged) {
        this.selectionChanged(e);
      }
    },
    onFocusedRowChanged: function (e) {
      var data = e.row && e.row.data;
      this.taskSubject = data && data.Task_Subject;
      this.taskDetails = data && data.Task_Description;
      this.taskStatus = data && data.Task_Status;
      this.focusedRowKey = e.component.option('focusedRowKey');
    },
    onGridCellClick(info) {
      //console.log("info", info)
      this.selectedRowData = info.data;

      if (this.onCellClick) {
        this.onCellClick(info);
      }
    },
    onGridRowDbClick(info) {
      if (this.onRowDbClick) {
        this.onRowDbClick(info);
      }
    },
    doneActions() {
      if (this.onRowDbClick) this.onRowDbClick({ data: this.selectedRowData });
    },
    onSelectionChanged(info) {
      var aa = this.dGrid.getSelectedRowsData();

      if (this.selectionChanged) {
        this.selectionChanged(info, { aa, se: this.dGrid.getSelectedRowsData() });
      }
    },
    clearSelectedRows() {
      this.dGrid.clearSelection();
      this.dGrid.deselectAll();

      if (this.clearSelection) {
        this.clearSelection();
      }
    },
    installmentBtnClickHandler(data) {
      this.$parent.showInstallments(data);
    },

    refreshGrid() {
      if (this.$refs[this.refName] && this.$refs[this.refName].instance) this.$refs[this.refName].instance.refresh();
    },
    checkForStation(station) {
      let prof = this.$store.getters.getUserProfile;
      if (!prof || !prof.employeeStationId || prof.employeeStationId < 0) return false;

      return prof.employeeStationId == station;
    },

    getClass(item) {
      //console.log("item", item.applicationId)

      if (this.conditionalFormattingAppIds && this.conditionalFormattingAppIds.length > 0 && item.applicationId && item.applicationId >= 0) {
        const index = this.conditionalFormattingAppIds.findIndex((object) => object.id === item.applicationId);
        if (index > -1) return this.conditionalFormattingAppIds[index].cssRules;
      }
    },
    applyRules(rules) {
      //console.log("rules", { ...rules })

      this.conditionalFormattingRules = rules;
      this.conditionalFormattingAppIds = [];

      this.data_source.forEach((app) => {
        this.conditionalFormattingRules.forEach((r) => {
          if (r.isExpression) {
            let flag = false;

            if (r.expressionsList.length == 1 && this.callEvaluate({ ...r.expressionsList[0] }, app, true)) flag = true;

            if (r.expressionsList.length > 1) {
              if (r.expressionsList[1].condition.id == 101)
                //AND
                flag = r.expressionsList.every((e) => this.callEvaluate({ ...e }, app, true));

              if (r.expressionsList[1].condition.id == 102)
                //OR
                flag = r.expressionsList.some((e) => this.callEvaluate({ ...e }, app, true));
            }

            if (flag) this.conditionalFormattingAppIds.push({ id: app.applicationId, cssRules: r.format });
          } else {
            if (this.callEvaluate(r, app)) this.conditionalFormattingAppIds.push({ id: app.applicationId, cssRules: r.format });
          }
        });
      });
    },
    callEvaluate(item, app, isExpression) {
      if (!item.applyToColumn || !item.applyToColumn.dataField) return true;

      let datafield = item.applyToColumn.dataField;
      let value1, value2, field;

      if (!app[datafield] && item.condition.id < 101) return false;

      if (typeof item.value1 == 'string') value1 = item.value1.toLowerCase();
      else value1 = item.value1;

      if (typeof item.value2 == 'string') value2 = item.value2.toLowerCase();
      else value2 = item.value2;

      if (typeof app[datafield] == 'string') field = app[datafield].toLowerCase();
      else field = app[datafield];

      if (field && value1 && item.applyToColumn.evaluateAsTime) return this.evaluateRuleAsTime(item, field, value1, value2, app, isExpression);
      else if (field && value1 && item.applyToColumn.dataType && item.applyToColumn.dataType == 'date')
        return this.evaluateRuleForDate(item, field, value1, value2, app, isExpression);
      else return this.evaluateRule(item, field, value1, value2, app, isExpression);
    },
    evaluateRuleAsTime(r, field, value1, value2) {
      let momentField;
      let momentValue1;
      let momentValue2;

      let temp = field.split(':');
      if (temp && temp.length > 1) {
        momentField = moment().set({ year: 2024, month: 10, date: 10, hours: temp[0], minutes: temp[1], seconds: 0 });
      } else return;

      momentValue1 = moment(new Date(value1)).isValid() ? moment(new Date(value1)).set({ year: 2024, month: 10, date: 10, seconds: 0 }) : null;
      momentValue2 = moment(new Date(value2)).isValid() ? moment(new Date(value2)).set({ year: 2024, month: 10, date: 10, seconds: 0 }) : null;

      switch (r.condition.id) {
        case 0: //EqualsToValue1
          if (momentField.hours() == momentValue1.hours() && momentField.minutes() == momentValue1.minute()) return true;
          break;
        case 1: //IsNotEqualToValue1
          if (momentField.hours() != momentValue1.hours() || momentField.minutes() != momentValue1.minutes()) return true;
          break;
        case 5: //IsGreaterThanValue1
          if (momentField.isAfter(momentValue1)) return true;
          break;
        case 6: //IsGreaterThanOrEqualValue1
          if (momentField.isSameOrAfter(momentValue1)) return true;
          break;
        case 7: //IsLessThanValue1
          if (momentField.isBefore(momentValue1)) return true;
          break;
        case 8: //IsLessThanOrEqualToValue1
          if (momentField.isSameOrBefore(momentValue1)) return true;
          break;
        case 9: //IsBetweenValue1AndValue2
          if (momentField.isBetween(momentValue1, momentValue2)) return true;
          break;
        case 10: //IsNotBetweenValue1AndValue2
          if (momentField.isBefore(momentValue1) || momentField.isAfter(momentValue2)) return true;
          break;
      }
    },
    evaluateRuleForDate(r, field, value1, value2) {
      let momentField = moment(new Date(field)).set({ minutes: 10, hours: 10, seconds: 0 });
      let momentValue1 = moment(new Date(value1)).isValid() ? moment(new Date(value1)).set({ minutes: 10, hours: 10, seconds: 0 }) : null;
      let momentValue2 = moment(new Date(value2)).isValid() ? moment(new Date(value2)).set({ minutes: 10, hours: 10, seconds: 0 }) : null;

      switch (r.condition.id) {
        case 0: //EqualsToValue1
          //console.log(momentField.day() , momentValue1.day() , momentField.month() , momentValue1.month() , momentField.year() , momentValue1.year())
          if (momentField.day() == momentValue1.day() && momentField.month() == momentValue1.month() && momentField.year() == momentValue1.year())
            return true;
          break;
        case 1: //IsNotEqualToValue1
          if (momentField.day() != momentValue1.day() || momentField.month() != momentValue1.month() || momentField.year() != momentValue1.year())
            return true;
          break;
        case 5: //IsGreaterThanValue1
          if (momentField.isAfter(momentValue1)) return true;
          break;
        case 6: //IsGreaterThanOrEqualValue1
          if (momentField.isSameOrAfter(momentValue1)) return true;
          break;
        case 7: //IsLessThanValue1
          if (momentField.isBefore(momentValue1)) return true;
          break;
        case 8: //IsLessThanOrEqualToValue1
          if (momentField.isSameOrBefore(momentValue1)) return true;
          break;
        case 9: //IsBetweenValue1AndValue2
          if (momentField.isBetween(momentValue1, momentValue2)) return true;
          break;
        case 10: //IsNotBetweenValue1AndValue2
          if (momentField.isBefore(momentValue1) || momentField.isAfter(momentValue2)) return true;
          break;
      }
    },
    evaluateRule(r, field, value1, value2) {
      switch (r.condition.id) {
        case 0: //EqualsToValue1
          if (field == value1) return true;
          break;
        case 1: //IsNotEqualToValue1
          if (field != value1) return true;
          break;
        case 2: //StartsWithValue1
          if (field.startsWith(value1)) return true;
          break;
        case 3: //EndsWithValue1
          if (field.endsWith(value1)) return true;
          break;
        case 4: //ContainsValue1
          if (field.includes(value1)) return true;
          break;
        case 5: //IsGreaterThanValue1
          if (field > value1) return true;
          break;
        case 6: //IsGreaterThanOrEqualValue1
          if (field >= value1) return true;
          break;
        case 7: //IsLessThanValue1
          if (field < value1) return true;
          break;
        case 8: //IsLessThanOrEqualToValue1
          if (field <= value1) return true;
          break;
        case 9: //IsBetweenValue1AndValue2
          if (field >= value1 && field <= value2) return true;
          break;
        case 10: //IsNotBetweenValue1AndValue2
          if (field < value1 || field > value2) return true;
          break;
        case 11: //NotEmpty
          if (field) return true;
          break;
        case 101: //AND
          return true;
        case 101: //OR
          return true;
      }

      return false;
    }

    //searchDialogClosed(items) {
    //  let indexes = [], curItem = {};
    //  if (items && items.length > 0) {
    //    let index = -1;

    //    for (let i = 0; i < items.length; i++) {
    //      curItem = items[i];
    //      index = this.data_source.findIndex(object => object.applicationId == curItem['applicationId']);

    //      if (index >= 0)
    //        indexes.push(index);
    //    }
    //  }

    //  this.rowsIndexSelected = [...indexes];
    //  if (this.rowsIndexSelected.length > 0 && indexes.length > 0)
    //    this.refreshGrid();

    //  this.showSearchDialog = false;
    //},
  }
};
